import {DefaultTimelineMetadata} from "../../../../../util/types";
import Card from "./Card";
import {findMetadata, isDateSameOrAfter} from "../../../../../util/helpers";
import IconWrench from "../../../../icons/IconWrench.tsx";

export const ContractorCard = ({metadata, timeline_type}: { metadata: DefaultTimelineMetadata[], timeline_type: string }) => {
    const active_date = findMetadata('product_instance_status_active_date', metadata);
    const is_online: boolean = isDateSameOrAfter(active_date);

    return <Card
        done={is_online}
        title="Fiberen bliver etableret på din grund"
        icon={IconWrench}
    >
        {timeline_type === 'tdc-fbsa' ?
            <p>
                Du får et opkald fra entreprenøren, hvor I aftaler, hvordan fiberen skal graves ned.
            </p>
            :
            <p>
                Entreprenøren kontakter dig for at aftale, hvordan fiberen skal graves ned på din grund.
            </p>
        }
    </Card>
}
